
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 12.961a6.508 6.508 0 00-6.5 6.5.472.472 0 00.472.472h12.056a.472.472 0 00.472-.472 6.507 6.507 0 00-6.5-6.5zm0 .944a5.561 5.561 0 015.533 5.085H6.968a5.561 5.561 0 015.532-5.085zM12.499 12.453a3.727 3.727 0 10-3.726-3.727 3.73 3.73 0 003.726 3.727zm0-6.509a2.783 2.783 0 11-2.783 2.783 2.786 2.786 0 012.783-2.783z"}})])
          )
        }
      }
    